import { X, MapPin, ExternalLink } from "lucide-react";

export const FeedCardPreview = ({ posterUrl, profile, name, band, services, basedIn, onClose }) => {
  const live = !!profile?.hireable_for_sessions;
  return (
    <div className="feed-modal-backdrop" onClick={onClose} data-testid="feed-preview-modal">
      <div className="feed-modal" onClick={(e) => e.stopPropagation()}>
        <div className="feed-modal-head">
          <div>
            <p className="feed-modal-kicker">LIVE FEED PREVIEW</p>
            <h3 className="feed-modal-title">How your card appears on londondrumsticks.co.uk</h3>
          </div>
          <button className="feed-modal-close" onClick={onClose} data-testid="feed-preview-close">
            <X size={18} />
          </button>
        </div>

        <div className="site-mock">
          <div className="site-mock-nav">
            <span className="site-mock-brand">LONDON DRUMSTICK CO.</span>
            <span className="site-mock-link">SESSION DRUMMERS</span>
          </div>
          <article className="site-card" data-testid="site-card">
            <div className="site-card-poster">
              {posterUrl ? <img src={posterUrl} alt="Session poster" /> : <div className="site-card-poster-empty">NO POSTER</div>}
            </div>
            <div className="site-card-body">
              <p className="site-card-tag">AVAILABLE FOR SESSIONS</p>
              <h4 className="site-card-name" data-testid="site-card-name">{name}</h4>
              {band && <p className="site-card-band">{band}</p>}
              {basedIn && (
                <p className="site-card-loc"><MapPin size={13} /> {basedIn}</p>
              )}
              {services.length > 0 && (
                <div className="site-card-services">
                  {services.map((s) => <span key={s} className="site-card-svc">{s}</span>)}
                </div>
              )}
              {profile?.session_intro_text && (
                <p className="site-card-intro">{profile.session_intro_text}</p>
              )}
              <button className="site-card-book" type="button" data-testid="site-card-book">
                BOOK {name.split(" ")[0]} <ExternalLink size={13} />
              </button>
            </div>
          </article>
        </div>

        <div className={`feed-status ${live ? "is-live" : "is-hidden"}`} data-testid="feed-status">
          {live
            ? "Your profile is marked Hireable — this card is published in the public feed once you Save to Profile."
            : "Your profile is NOT marked Hireable yet — toggle “Available for Sessions” in your Session Database to appear on the site."}
        </div>
      </div>
    </div>
  );
};
